import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import VizyonSektorPage from "./pages/VizyonSektorPage";
import SearchPage from "./pages/SearchPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminNewsForm from "./pages/admin/AdminNewsForm";
import AdminAds from "./pages/admin/AdminAds";
import AdminPageEditor from "./pages/admin/AdminPageEditor";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminSettings from "./pages/admin/AdminSettings";
import StaticPage from "./pages/StaticPage";
import ContactPage from "./pages/ContactPage";

// Utilities
import ScrollToTop from "./components/layout/ScrollToTop";

// Context
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-white">
          <Toaster position="top-right" richColors />
          <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/kategori/:slug" element={<CategoryPage />} />
            <Route path="/haber/:id" element={<NewsDetailPage />} />
            <Route path="/vizyon-sektor" element={<VizyonSektorPage />} />
            <Route path="/arama" element={<SearchPage />} />
            <Route path="/admin/giris" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/haber/ekle" element={<AdminNewsForm />} />
            <Route path="/admin/haber/:id" element={<AdminNewsForm />} />
            <Route path="/admin/reklamlar" element={<AdminAds />} />
            <Route path="/admin/sayfa/:slug" element={<AdminPageEditor />} />
            <Route path="/admin/talepler" element={<AdminInquiries />} />
            <Route path="/admin/ayarlar" element={<AdminSettings />} />
            <Route path="/hakkimizda" element={<StaticPage slug="hakkimizda" />} />
            <Route path="/reklam-isbirligi" element={<StaticPage slug="reklam-isbirligi" />} />
            <Route path="/iletisim" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
        </div>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
